import styled from "styled-components";

export const ContainerMetrics = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-y: auto;
  margin-top: 20px;
  padding-bottom: 20px;
  height: auto;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 90%;
  gap: 100px;
  align-items: center;

  @media (max-width: 1200px) {
    width: 64%;
    flex-direction: column;
    gap: 30px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 50px;
  align-items: center;
`;

export const Button = styled.button`
  background-color: white;
  color: black;
  padding: 10px 20px;
  margin: 10px;
  border: 2px solid red;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background-color: #efecec;
  }

  &:active {
    background-color: red !important;
    color: white !important;
  }
`;

export const ContainerChart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: 0 0 0 30px;
`;
